var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["./loyalty-subscribed.j2"] = require( "./loyalty-subscribed.j2" );
dependencies["./loyalty-unsubscribed.j2"] = require( "./loyalty-unsubscribed.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/loyalty.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "account/templates/partials/loyalty.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("genericUrl")) {
var t_4 = t_1.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_4);
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"formFocus") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"focusValue") != "urban-on") {
output += "\n\n<div id=\"urban-on\" class=\"c-profile__section c-profile__section--loyalty is-focused\">\n\n";
;
}
else {
output += "\n\n<div id=\"urban-on\" class=\"c-profile__section c-profile__section--loyalty\">\n\n";
;
}
output += "\n\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            <div class=\"c-profile__h2-outer\">\n\n                <h2 class=\"c-profile__h2\">\n\n                    ";
output += runtime.suppressValue((lineno = 21, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-loyalty-program",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n                </h2>\n\n            </div>\n\n            ";
output += "\n            ";
if(!runtime.memberLookup((runtime.memberLookup(((lineno = 28, colno = 31, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["initialized"]))),"subscriptions")),"postNeeded") && runtime.memberLookup((runtime.memberLookup(((lineno = 28, colno = 87, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["subscriptions"]))),"loyalty")),"loyaltyId")) {
output += "\n\n                ";
env.getTemplate("./loyalty-subscribed.j2", false, "account/templates/partials/loyalty.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n            ";
})});
}
else {
output += "\n\n                ";
output += "\n                ";
env.getTemplate("./loyalty-unsubscribed.j2", false, "account/templates/partials/loyalty.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n            ";
})});
}
output += "\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/loyalty.j2"] , dependencies)